// extracted by mini-css-extract-plugin
export default {"wrapper":"footer_wrapper__m5NXw"};